import { render, staticRenderFns } from "./ApprovedButton.vue?vue&type=template&id=455d8362&scoped=true&"
import script from "./ApprovedButton.vue?vue&type=script&lang=js&"
export * from "./ApprovedButton.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedButton.vue?vue&type=style&index=0&id=455d8362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455d8362",
  null
  
)

component.options.__file = "ApprovedButton.vue"
export default component.exports